import { ControlOverLegalClientStatusType } from 'api/types/entity';
import { GridFields } from 'components';
import { getYesOrNoOptions } from 'helpers';
import { useTranslation } from 'libs/i18n';

import { Field } from '../../../../forms/controlOverForm';

export interface FormContentProps {
  enabledFinancialConditionAmount: boolean;
  enabledControlOverLegalClientStatus: boolean;
  enabledHasControlOverLegalClient: boolean;
}

export const FormContent = ({
  enabledControlOverLegalClientStatus,
  enabledFinancialConditionAmount,
  enabledHasControlOverLegalClient,
}: FormContentProps) => {
  const { t } = useTranslation();

  return (
    <GridFields>
      {enabledControlOverLegalClientStatus && (
        <Field.Autocomplete
          showRequiredMark
          label={t(
            'client.legal.legalClientBeneficiary.controlOver.controlOverLegalClientStatus.label'
          )}
          name="controlOver.controlOverLegalClientStatus"
          optionLabelKey="label"
          options={Object.values(ControlOverLegalClientStatusType).map((v) => ({
            label: t(
              `client.legal.legalClientBeneficiary.controlOver.controlOverLegalClientStatus.types.${v}`
            ),
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t('common.selectPlaceholder')}
          variant="select"
        />
      )}

      {enabledHasControlOverLegalClient && (
        <Field.Autocomplete
          showRequiredMark
          label={t(
            'client.legal.legalClientBeneficiary.controlOver.hasControlOverLegalClient.label'
          )}
          name="controlOver.hasControlOverLegalClient"
          optionLabelKey="label"
          options={getYesOrNoOptions(t)}
          optionValueKey="value"
          placeholder={t('common.selectPlaceholder')}
          variant="select"
        />
      )}

      <Field.Number
        fullWidth
        showRequiredMark
        format={(v) => (!v ? v : Number(v))}
        label={t(
          'client.legal.legalClientBeneficiary.controlOver.directCapitalParticipationPercentage.label'
        )}
        maxNumber={100}
        name="controlOver.directCapitalParticipationPercentage"
        placeholder={t(
          'client.legal.legalClientBeneficiary.controlOver.directCapitalParticipationPercentage.placeholder'
        )}
      />

      <Field.Number
        fullWidth
        format={(v) => (!v ? v : Number(v))}
        label={t(
          'client.legal.legalClientBeneficiary.controlOver.indirectCapitalParticipationPercentage.label'
        )}
        maxNumber={100}
        name="controlOver.indirectCapitalParticipationPercentage"
        placeholder={t(
          'client.legal.legalClientBeneficiary.controlOver.indirectCapitalParticipationPercentage.placeholder'
        )}
      />

      {enabledFinancialConditionAmount && (
        <Field.PriceAndCurrency
          fullWidth
          showRequiredMark
          label={t(
            'client.legal.legalClientBeneficiary.controlOver.financialConditionAmount.label'
          )}
          name="controlOver.financialConditionAmount"
          placeholder={t(
            'client.legal.legalClientBeneficiary.controlOver.financialConditionAmount.placeholder'
          )}
        />
      )}
    </GridFields>
  );
};
